var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Calendar-Table"},_vm._l((12),function(month){return _c('CalendarMonth',{key:month,attrs:{"year":_vm.year,"month":month - 1}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }